import { API } from '@aws-amplify/api';

export interface GetStudentHoursLeftInput {
  studentId: string;
}

export interface GetStudentHoursLeftOutput {
  hoursLeft: number;
}

export const getStudentHoursLeft = async (
  input: GetStudentHoursLeftInput
): Promise<GetStudentHoursLeftOutput> => {
  try {
    const apiName = process.env.NEXT_PUBLIC_LEARNING_API_NAME!;
    const path = `api/nextgen/hours/left`;
    const myInit = {
      headers: {},
      queryStringParameters: { studentId: input.studentId },
    };

    const response = await API.get(apiName, path, myInit);
    return response;
  } catch (error) {
    console.error('Error getting student hours left:', error);
    throw error;
  }
};
